module.exports = "/_next/static/images/4009de0240f415cf24e17fe89af9d185-bubble-gum-woman-square@md-1x.jpg.webp";